export default __webpack_public_path__ + "static/media/chart-white.eaf0118c.svg";